// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Add props: adminOnly, companyOnly
const ProtectedRoute = ({ children, adminOnly = false, companyOnly = false }) => {
    const { currentUser, userData } = useAuth();
    const location = useLocation();

    if (!currentUser) {
        // Not logged in, redirect to login page
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (adminOnly && userData?.role !== 'admin') {
        // Logged in but not an admin, redirect to dashboard
        return <Navigate to="/dashboard" replace />;
    }

    if (companyOnly) {
        if (userData?.role !== 'company') {
            // Not a company, redirect
            return <Navigate to="/dashboard" replace />;
        }
        if (!userData?.isApproved) {
            // Company but not approved yet
            return (
                <div className="container mx-auto p-8 text-center">
                    <h1 className="text-2xl font-bold">Hesabınız Onay Bekliyor</h1>
                    <p className="mt-4 text-gray-600">Şirket hesabınız yönetici tarafından inceleniyor. Onaylandığında panelinize erişebileceksiniz.</p>
                </div>
            );
        }
    }
    
    // If all checks pass, render the child component
    return children;
};

export default ProtectedRoute;